// ─────────────────────────────────────────────
//  assignmentNotice — what a saved assignment SAYS, and whether it is worth
//  saying at all.
//
//  Lifted out of AssignmentModal (703 lines, over the 500-line house rule).
//  Both are pure string/comparison logic with no React and no Firestore, so
//  they belong beside the other domain rules rather than inside the largest
//  component in the app. AssignmentModal imports and re-exports them, so every
//  existing call site and test keeps working.
// ─────────────────────────────────────────────
import { hmToMinutes, to12h } from "./timeline";

// ── THE MESSAGE ──────────────────────────────
// Built in ONE place so the sentence a provider reads is the sentence this file
// can be tested against: "New assignment time — WOR 1, 1 PM–5 PM."
//
// ⚠️ NO COMPLETION LANGUAGE. This says where someone is expected; it never
// claims anything has happened (src/domain/tasks.js: confirm means "I am
// aware", not "I did it").
//
// Times are formatted with the board's own `to12h`, so 13:00 reads "1 PM"
// exactly as it does on every timeline axis and shift label — a second 12-hour
// formatter here would drift from the surface the same people are looking at.
export function assignmentMessage({ roomName, startTime, endTime }) {
  const span = [startTime, endTime]
    .map((t) => to12h(hmToMinutes(t)))
    .filter(Boolean)
    .join("–");
  const where = roomName || "your room";
  // Doctor-only New Room mode renders no time fields at all. Saying "new
  // assignment TIME" with no time in the sentence promises a number that is
  // not there, so the wording drops the word rather than the message.
  return span ? `New assignment time — ${where}, ${span}.` : `New assignment — ${where}.`;
}

// ⚠️ WHAT MAKES A SAVE WORTH A PHONE BUZZ. Only the facts the sentence
// actually carries (the hours) plus WHO is standing in the room. A surgeon
// swap or a relief-name correction changes the row but would send a "New
// assignment time" that names the same time — noise that teaches people to
// ignore the lane.
const NOTIFY_FIELDS = ["startTime", "endTime", "ahpId", "attendingId"];

export function rowNeedsNotice(before, after) {
  if (!before) return true; // a row that did not exist a moment ago is news
  return NOTIFY_FIELDS.some((k) => (before[k] || "") !== (after[k] || ""));
}
